import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=3586dcc5&"
import script from "./DocumentViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports